const studentRoutes = [
  {
    path: '/kursant',
    redirect: '/admin/dashboard',
    component: () => import('@/views/Layouts/SidebarContent'),
    meta: {
      allowedUserTypes: ['student']
    },
    children: [
      {
        path: 'dashboard',
        component: () => import('@/views/StudentPanel/Dashboard/'),
        meta: {
          title: 'Dashboard'
        }
      },
      {
        path: 'profil',
        component: () => import('@/views/StudentPanel/Profile/'),
        meta: {
          title: 'Mój profil'
        }
      },
      {
        path: 'aplikacje',
        component: () => import('@/views/StudentPanel/Applications/'),
        meta: {
          title: 'Aplikacje'
        }
      },
      {
        path: 'kursy',
        component: () => import('@/views/StudentPanel/Course/List/'),
        meta: {
          title: 'Lista kursów'
        }
      },
      {
        path: 'rozliczenia',
        component: () => import('@/views/StudentPanel/Payments/'),
        meta: {
          title: 'Rozliczenia'
        }
      },
      {
        path: 'kursy/szczegoly/:courseId',
        component: () => import('@/views/StudentPanel/Course/Details/'),
        children: [
          {
            path: 'info',
            component: () =>
              import('@/views/StudentPanel/Course/Details/Info/'),
            meta: {
              title: 'Informacje o kursie'
            }
          },
          {
            path: 'kalendarz',
            component: () =>
              import('@/views/StudentPanel/Course/Details/Calendar/'),
            meta: {
              title: 'Kalendarz kursu'
            }
          },
          {
            path: 'lektor',
            component: () =>
              import('@/views/StudentPanel/Course/Details/Lecturer/'),
            meta: {
              title: 'Informacje o lektorze'
            }
          },
          {
            path: 'kursanci',
            component: () =>
              import('@/views/StudentPanel/Course/Details/Students/'),
            meta: {
              title: 'Lista kursantów'
            }
          },
          {
            path: 'materialy-dydaktyczne',
            component: () =>
              import('@/views/StudentPanel/Course/Details/Materials/'),
            meta: {
              title: 'Materiały dydaktyczne'
            },
            props: true
          },
          {
            path: 'historia-zajec',
            component: () =>
              import('@/views/StudentPanel/Course/Details/History/'),
            props: true,
            meta: {
              title: 'Historia zajęć'
            }
          }
        ]
      },
      {
        path: 'biblioteka',
        redirect: 'biblioteka/kursy',
        component: () => import('@/views/StudentPanel/Library/'),
        children: [
          {
            path: 'kursy',
            component: () =>
              import('@/views/StudentPanel/Library/ForCoursesTab/'),
            meta: {
              title: 'Biblioteka dla kursów'
            }
          },
          {
            path: 'kursanci',
            props: true,
            component: () =>
              import('@/views/StudentPanel/Library/ForStudentsTab/'),
            meta: {
              title: 'Biblioteka dla studentów'
            }
          }
        ]
      }
    ]
  }
]

export default studentRoutes
